function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "0%",
  y1: "0%",
  y2: "100%",
  id: "a"
}, React.createElement("stop", {
  stopColor: "#FC933C",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FFE14B",
  offset: "100%"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.9 36.3V65h-5V35.9l-.9-2.6.1-.8L0 36.8l6.4-23-1.7.6 5.4-9.5-3.8 23 7.7-3.7L16.5 0 19 24.2l7.7 3.7-3.8-23 5.4 9.5-1.7-.6 6.4 23-13.1-4.3v.8l-1 3z",
  fill: "url(#a)"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 33,
    height: 65
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/trident.06d4cb99.svg";
export { SvgComponent as ReactComponent };